import _objectSpread from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import userTagCom from './userTagCom.vue';
import { getClock, addClock } from '@/api/admissionCounseling/myCustomers';
import moment from 'moment';
import { getInvalidTypeOpts } from '@/api/frontEndManagement/invalidType';
import { editIntention as _editIntention } from '@/api/admissionCounseling/customerDrawerCom';
import { evaluationList } from '@/utils/dictionary';
import aiTagCom from './aiTagCom.vue';
import DeepseekTagIcon from '@/assets/images/deepseek-tag.png';
export default {
  name: 'RightCom',
  components: {
    userTagCom: userTagCom,
    aiTagCom: aiTagCom
  },
  props: {
    cId: {
      type: Number,
      required: true
    },
    selectedLabel: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    crmLabel: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    canEdit: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    info: {
      //  给闹钟用
      type: Object,
      required: true
    },
    aiErrorReasonOpt: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    var _this = this;
    return {
      // eslint-disable-next-line vue/no-reserved-keys
      _this: _this,
      DeepseekTagIcon: DeepseekTagIcon,
      invalidTypeOpt: [],
      evaluationOpt: evaluationList.slice(0, 3),
      contactNoResultOpt: [],
      correctIntentionOpt: [
      // 意向度
      {
        id: 1,
        label: 'A-意向很高'
      }, {
        id: 2,
        label: 'B-意向较高'
      }, {
        id: 3,
        label: 'C-意向中等'
      }, {
        id: 4,
        label: 'D-意向较低'
      }, {
        id: 5,
        label: 'E-意向很低'
      }],
      intentionOpt: ['E-意向很低', 'D-意向较低', 'C-意向中等', 'B-意向较高', 'A-意向很高'],
      form: {
        evaluation: _this.formData.evaluation,
        intentionLevel: _this.formData.intentionLevel,
        invalidTypeId: _this.formData.invalidTypeId,
        label: _this.formData.label,
        remark: '',
        loading: false,
        aiLabel: [],
        aiAdvice: _this.formData.aiAdvice
      },
      submitLoading: false,
      userTag: {
        isExist: false,
        visible: false,
        selectedTag: _this.selectedLabel
      },
      clock: {
        loading: false,
        oldStatus: undefined
      },
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          return moment(date).isBefore(moment());
        }
      },
      rules: {
        intentionLevel: [{
          required: true,
          message: '请选择意向度',
          trigger: 'blur'
        }],
        invalidTypeId: [{
          required: true,
          message: '请选择理由',
          trigger: 'blur'
        }]
      },
      rules1: {
        revisitTime: [{
          required: true,
          message: '开启提醒闹钟需要选择时间',
          trigger: 'blur'
        }]
      },
      confirm: false
    };
  },
  computed: {
    evaluationName: function evaluationName() {
      var evaluationOpt = this.evaluationOpt,
        form = this.form;
      var name = evaluationOpt.filter(function (item) {
        return item.id === form.evaluation;
      });
      return name.length ? name[0].label : '';
    }
  },
  watch: {
    cId: function cId(newVal) {
      // 之后客户的变化
      if (newVal) {
        var handleFormLoading = this.handleFormLoading,
          init = this.init;
        handleFormLoading();
        // 延迟赋值，formData传值没那么快
        setTimeout(function () {
          init();
        }, 1000);
      }
    },
    'formData.evaluation': function formDataEvaluation(val, oldVal) {
      // 初次渲染
      if (oldVal === undefined) {
        var handleFormLoading = this.handleFormLoading,
          init = this.init;
        handleFormLoading();
        init();
      }
    },
    'clock.status': function clockStatus(newVal, oldVal) {
      this.clock.oldStatus = oldVal;
    },
    'form.evaluation': function formEvaluation(newVal, oldVal) {
      var invalidTypeOpt = this.invalidTypeOpt,
        form = this.form,
        getInvalidTypesList = this.getInvalidTypesList,
        contactNoResultOpt = this.contactNoResultOpt;
      if (newVal === 1) {
        // 咨询评价选中静默时，意向度只能选择F-静默数据6
        form.intentionLevel = 6;
        !invalidTypeOpt.length && getInvalidTypesList(1);
      } else if (oldVal === 1) {
        form.intentionLevel = undefined;
      }
      if (newVal === 2) {
        !contactNoResultOpt.length && getInvalidTypesList(2);
      }
      // 在联系未果里选了理由，切换成建议静默，理由应该清空，不然就带不匹配的理由了
      form.invalidTypeId && (form.invalidTypeId = undefined);
    },
    'formData.aiLabel': function formDataAiLabel(newVal, oldVal) {
      if (newVal.length !== oldVal.length) {
        this.form.aiLabel = newVal;
      }
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var form, formData, getRevisitClock, handleFormLoading, switchIntentionLevel, confirm, getAiErrorReasonOpt, userTag, selectedLabel;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // 不在组件调接口，是因为隔离数据，为了监听是否有改动
              form = _this2.form, formData = _this2.formData, getRevisitClock = _this2.getRevisitClock, handleFormLoading = _this2.handleFormLoading, switchIntentionLevel = _this2.switchIntentionLevel, confirm = _this2.confirm, getAiErrorReasonOpt = _this2.getAiErrorReasonOpt, userTag = _this2.userTag, selectedLabel = _this2.selectedLabel;
              _context.n = 1;
              return getRevisitClock().finally(function () {
                var evaluation = formData.evaluation,
                  invalidTypeId = formData.invalidTypeId,
                  label = formData.label,
                  aiLabel = formData.aiLabel,
                  aiAdvice = formData.aiAdvice;
                form.evaluation = evaluation;
                form.intentionLevel = switchIntentionLevel();
                form.invalidTypeId = invalidTypeId;
                form.label = label;
                form.aiLabel = aiLabel;
                form.aiAdvice = aiAdvice;
                userTag.selectedTag = selectedLabel;
                confirm && (_this2.confirm = false);
                handleFormLoading();
                getAiErrorReasonOpt();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    //  查询静默类型列表
    getInvalidTypesList: function getInvalidTypesList(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, temp;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getInvalidTypeOpts({
                type: type
              });
            case 1:
              res = _context2.v;
              temp = res.content.map(function (item) {
                if (item.status) {
                  return {
                    id: item.id,
                    name: item.name
                  };
                }
              }).filter(function (item) {
                return item;
              });
              if (type === 1) {
                _this3.invalidTypeOpt = temp;
              } else {
                _this3.contactNoResultOpt = temp;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var correctIntentionOpt = this.correctIntentionOpt,
        intentionOpt = this.intentionOpt,
        formData = this.formData,
        form = this.form,
        $message = this.$message,
        $refs = this.$refs,
        userTag = this.userTag,
        handleConfirm = this.handleConfirm;
      var evaluation = form.evaluation,
        label = form.label,
        intentionLevel = form.intentionLevel,
        invalidTypeId = form.invalidTypeId;
      var initIntentionLevel = formData.evaluation ? formData.intentionLevel : formData.intentionLevel === 7 && !intentionLevel ? 0 : formData.intentionLevel === 7 ? 7 : correctIntentionOpt.filter(function (item) {
        return item.label === intentionOpt[formData.intentionLevel - 1];
      })[0].id;
      if (formData.evaluation === evaluation && formData.label === label && initIntentionLevel === intentionLevel && formData.invalidTypeId === invalidTypeId && !form.remark && !userTag.selectedTag.length) {
        $message({
          type: 'info',
          message: '没有更改的内容可提交哟'
        });
      } else {
        $refs['right-form'].validate(function (isPass) {
          if (isPass) {
            handleConfirm();
          } else {
            return false;
          }
        });
      }
    },
    handleCancel: function handleCancel() {
      var $refs = this.$refs;
      $refs['right-form'].resetFields();
    },
    handleUserTag: function handleUserTag() {
      var userTag = this.userTag;
      !userTag.isExist && (userTag.isExist = true);
      userTag.visible = !userTag.visible;
    },
    newTag: function newTag(_newTag) {
      var userTag = this.userTag,
        handleUserTag = this.handleUserTag;
      userTag.selectedTag = _newTag;
      handleUserTag();
    },
    // 查询闹钟
    getRevisitClock: function getRevisitClock() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var $refs, cId, $store, clock, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              $refs = _this4.$refs, cId = _this4.cId, $store = _this4.$store, clock = _this4.clock;
              clock.status = 0;
              $refs['bottom-form'].resetFields();
              _context3.n = 1;
              return getClock({
                cId: cId,
                id: $store.state.user.user.id
              });
            case 1:
              res = _context3.v;
              _this4.clock = _objectSpread(_objectSpread({}, clock), res);
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleSaveClock: function handleSaveClock() {
      var clock = this.clock,
        $refs = this.$refs,
        $message = this.$message,
        saveClock = this.saveClock;
      if (clock.status) {
        $refs['bottom-form'].validate(function (isPass) {
          if (isPass) {
            saveClock();
          } else {
            return false;
          }
        });
      } else {
        if (clock.oldStatus !== clock.status) {
          saveClock();
        } else {
          $message({
            type: 'error',
            message: '没有改动无需保存~'
          });
        }
      }
    },
    saveClock: function saveClock() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var cId, clock, $message, refreshClock, data, res, status, id;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              cId = _this5.cId, clock = _this5.clock, $message = _this5.$message, refreshClock = _this5.refreshClock;
              data = {
                status: clock.status,
                revisitTime: clock.revisitTime
              };
              _context4.n = 1;
              return addClock(cId, data);
            case 1:
              res = _context4.v;
              status = res.status, id = res.id;
              if (status) {
                $message({
                  type: 'success',
                  message: '开启弹窗提醒闹钟成功~'
                });
                // 开下次回访时间的闹钟，才刷新
                setTimeout(function () {
                  refreshClock(id);
                }, 2000);
              } else {
                $message({
                  type: 'success',
                  message: '关闭弹窗提醒闹钟成功~'
                });
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 刷新回访闹钟（设置闹钟之后就更新回访闹钟提示）
    refreshClock: function refreshClock(clockId) {
      var cId = this.cId,
        $alarm = this.$alarm,
        clock = this.clock,
        info = this.info;
      var name = info.name,
        contactPhone = info.contactPhone,
        contactWechat = info.contactWechat;
      var newTimerId = setTimeout(function () {
        $alarm({
          timerId: newTimerId,
          id: clockId,
          // clockId， 闹钟id
          name: name,
          contactPhone: contactPhone,
          contactWechat: contactWechat,
          customerId: cId
        });
      }, moment(clock.revisitTime).diff(moment()));
    },
    handleSubmitLoading: function handleSubmitLoading() {
      this.submitLoading = !this.submitLoading;
    },
    editIntention: function editIntention() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var cId, correctIntentionOpt, intentionOpt, userTag, form, submitSuccess, evaluation, intentionLevel, invalidTypeId, data, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              cId = _this6.cId, correctIntentionOpt = _this6.correctIntentionOpt, intentionOpt = _this6.intentionOpt, userTag = _this6.userTag, form = _this6.form, submitSuccess = _this6.submitSuccess;
              evaluation = form.evaluation, intentionLevel = form.intentionLevel, invalidTypeId = form.invalidTypeId;
              data = {
                id: cId,
                evaluation: evaluation,
                intentionLevel: evaluation ? intentionLevel : correctIntentionOpt.filter(function (item) {
                  return item.label === intentionOpt[intentionLevel - 1];
                })[0].id,
                invalidTypeId: invalidTypeId,
                label: userTag.selectedTag.map(function (item) {
                  return item.id;
                }),
                remark: form.remark
              };
              _context5.n = 1;
              return _editIntention(data);
            case 1:
              res = _context5.v;
              submitSuccess(res);
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    submitSuccess: function submitSuccess(res) {
      var $message = this.$message,
        form = this.form,
        confirm = this.confirm;
      if (typeof res === 'string') {
        $message({
          type: 'success',
          message: '提交成功~'
        });
        // 触发左边跟进记录刷新
        form.remark = '';
        this.$emit('submitSuccess');
        confirm && (this.confirm = false);
      }
    },
    handleFormLoading: function handleFormLoading() {
      var form = this.form;
      form.loading = !form.loading;
    },
    handleConfirm: function handleConfirm() {
      // v7.7 提交跟进备注时，如果评价栏未做更改，且状态非“有效”，则提交时需要二次弹窗提示；如更改或为“有效”，则无弹窗直接提交。
      var formData = this.formData,
        form = this.form,
        handleConfirmVisible = this.handleConfirmVisible,
        confirmSubmit = this.confirmSubmit;
      var evaluation = form.evaluation;
      if (formData.evaluation === evaluation && evaluation !== 0) {
        handleConfirmVisible();
      } else {
        confirmSubmit();
      }
    },
    handleConfirmVisible: function handleConfirmVisible() {
      this.confirm = !this.confirm;
    },
    confirmSubmit: function confirmSubmit() {
      var handleSubmitLoading = this.handleSubmitLoading,
        editIntention = this.editIntention,
        formData = this.formData,
        form = this.form;
      // v7.10.5 已成交客户，不可放弃和静默！！
      if (formData.registered && form.evaluation === 1) {
        this.$message({
          type: 'error',
          message: '已成交客户，不可静默！！'
        });
        return false;
      }
      handleSubmitLoading();
      // v6.4
      editIntention();
      handleSubmitLoading();
    },
    switchIntentionLevel: function switchIntentionLevel() {
      var formData = this.formData,
        correctIntentionOpt = this.correctIntentionOpt,
        intentionOpt = this.intentionOpt;
      var evaluation = formData.evaluation,
        intentionLevel = formData.intentionLevel;
      switch (evaluation) {
        // 有效
        case 0:
          // 无意向度
          if (intentionLevel === 7) {
            return 0;
          } else {
            return correctIntentionOpt.filter(function (item) {
              return item.label === intentionOpt[intentionLevel - 1];
            })[0].id;
          }
        case 1:
        case 2:
        case 3:
          // 无意向度
          if (intentionLevel === 7) {
            return 0;
          } else {
            return intentionLevel;
          }
        default:
          break;
      }
    },
    refreshAiTag: function refreshAiTag(id) {
      var form = this.form;
      form.aiLabel = form.aiLabel.filter(function (item) {
        return item.id !== id;
      });
      this.$emit('submitSuccess');
    }
  }
};